export default "__VITE_ASSET__6ba868e0__"